<template>
	<div v-bind:class="computedClass" style="border-right: 1px solid #e5e5e5">
		<div class="col-lg-12">
			<h3 class="titleH3">{{ title }}</h3>
		</div>
		<div class="col-lg-12">
			<div v-if="loading" class="dynvibeLoading" style="min-height: 295px"></div>
			<ul v-else-if="categories.length > 0">
				<li
					v-for="category in categories"
					v-bind:key="category.key"
					@click="clickOnCategory(category)"
					:class="activeClass(category)"
				>
					<div class="row" style="margin: 0px 0px 5px 0px">
						<div class="col-xs-3" style="text-align: right; padding-right: 0">
							<span class="menuCategoryVal">
								<span class="dynvibePercent">{{ getPercentage(category) }}%</span>
								({{ category.profiles_count.value }})
							</span>
							<span v-bind:class="'menuCategoryPercent ' + object + ' ' + color">{{ getPercentage(category) }}%</span>
						</div>
						<div class="col-xs-9">
							<span class="menuCategoryName">{{ category.key }}</span>
							<div class="menuCategoryBar">
								<div class="menuCategoryBarComplete" v-bind:style="{ width: getPercentage(category) + '%' }"></div>
							</div>
						</div>
					</div>
				</li>
			</ul>
			<div v-else class="noData"><p>No Data to display</p></div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		object: {
			type: String,
			default: "",
		},
		request: {
			type: String,
			default: "",
		},
		title: {
			type: String,
			default: "",
		},
		color: {
			type: String,
			default: "",
		},
		first: {
			type: Boolean,
			default: false,
		},
		filters: {
			type: Object,
			default: function () {
				return {};
			},
		},
		columns: {
			type: Number,
			default: 3,
		},
	},
	data() {
		return {
			loading: true,
			total: 0,
			categories: [],
			activeCategory: null,
		};
	},
	computed: {
		computedClass() {
			//return this.request === "tag" ? "col-lg-3" : "col-lg-4";
			let width = 12 / this.columns;
			return "col-lg-" + width;
		},
	},
	methods: {
		loadComponent(/*parameters*/) {
			// parameters = {...this.filters}
			// this.loading = true;
			let params = {
				parameters: this.filters,
				data: {
					type: this.object,
					request: this.request,
				},
			};
			this.getData("listCategory", params); // no 'parameters' key, only data (the right one though)
		},
		treatResponse(response) {
			this.categories = response.data.categories;
			this.total = response.data.total;
			this.loading = false;
		},
		activeClass(category) {
			if (this.activeCategory !== null) {
				if (this.activeCategory.key == category.key) {
					return "active";
				}
			}
			return false;
		},
		getPercentage(category) {
			return Math.round((category.profiles_count.value / this.total) * 100);
		},
		clickOnCategory(category) {
			this.activeCategory = category;
			this.$emit("clickoncategory", category);
		},
		removeActiveCategory() {
			this.activeCategory = null;
		},
	},
	// watch: {
	// 	filters: {
	// 		handler() {
	// 			this.loadComponent(this.filters);
	// 		},
	// 		deep: true,
	// 		immediate: true,
	// 	}
	// },
};
</script>

<style scoped>
ul li {
	display: list-item;
}

li.active .menuCategoryPercent.category {
	color: rgb(247, 177, 169);
}

.menuCategoryPercent.red {
	color: rgb(247, 177, 169);
}

.menuCategoryPercent.blue {
	color: rgb(190, 238, 236);
}
</style>
